import type { AlgoliaHit } from '../../types';
import { Col, Row, Stack } from '@workramp/ui';
import { SearchResult } from '../SearchResult';
import { StyledResultsLength } from '../SearchResult/SearchResult.styles';

export function ResultsTable({
  results,
  academyContentTypesToLocalizedString,
}: {
  results: AlgoliaHit[];
  academyContentTypesToLocalizedString: Record<string, string>;
}) {
  if (!results) return null;

  return (
    <Stack size={4}>
      <Row>
        {results && (
          <Col>
            <StyledResultsLength size={3}>{results.length} results</StyledResultsLength>
          </Col>
        )}
      </Row>
      {results.map((r) => (
        <SearchResult
          key={r.objectID}
          hit={r}
          academyContentTypesToLocalizedString={academyContentTypesToLocalizedString}
        />
      ))}
    </Stack>
  );
}
